/**
 * Instructor purchasing portal order tagging for Pipedrive sync.
 * Admin/Jupiter must never send these values from this app.
 */
export const ORDER_SOURCE = 'instructor_portal'

/** Always false in the instructor purchasing portal. */
export const FROM_ADMIN_PORTAL = false

/** Fields for JSON bodies on generate / update / related purchasing writes. */
export function instructorPortalOrderSourceFields() {
  return {
    orderSource: ORDER_SOURCE,
    fromAdminPortal: FROM_ADMIN_PORTAL,
  }
}

/**
 * Append the same tags to multipart FormData (PO / tax-exempt uploads).
 * @param {FormData} form
 */
export function appendInstructorPortalOrderSource(form) {
  form.append('orderSource', ORDER_SOURCE)
  form.append('fromAdminPortal', String(FROM_ADMIN_PORTAL))
}
